module.exports = __webpack_public_path__ + "img/iphone_backImg.8f7788a1.png";